import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface MainProps extends ComponentPropsWithoutRef<"main"> {
  children: ReactNode;
  className?: string;
}

export const Main = ({ children, className, ...rest }: MainProps) => (
  <main
    className={classNames(
      "text-default bg-secondary relative grid h-full w-full overflow-hidden [grid-area:main] [grid-template-areas:'canvas_right-sidebar'] [grid-template-columns:1fr_auto]",
      className,
    )}
    data-testid="builder-ui-main"
    {...rest}
  >
    {children}
  </main>
);
